<template>
    <v-container fill-height fluid pa-0>
        <v-row align="center" class="fill-height" justify="start">
            <JourneyPhaseProgress :duration="4000"
                                  @complete="complete($event)"
                                  mode="in"
                                  v-if="type==='phase'"
            ></JourneyPhaseProgress>
            <JourneyMeasureProgress :animate="4000"
                                    @complete="complete($event)"
                                    mode="in"
                                    v-else
            ></JourneyMeasureProgress>
        </v-row>
    </v-container>
</template>

<script>
    import JourneyPhaseProgress from "../progress/JourneyPhaseProgress";
    import JourneyMeasureProgress from "../progress/JourneyMeasureProgress";
    import applicationEventHub from "../../events/applicationEventHub";

    export default {
        name: "JourneyProgressRenderer",
        components: {
            JourneyPhaseProgress,
            JourneyMeasureProgress
        },
        props: {
            type: {
                type: String,
                default: 'phase'
            }
        },
        mounted(){
          applicationEventHub.frameworkNavigationDisplay(false);
        },
        methods: {
            complete() {
                this.$emit('complete');
            }
        }
    }
</script>

<style scoped>

</style>